import { filter, find } from 'ramda';

interface RheologyAvailability {
  isComplete?: boolean;
  isDeactivated?: boolean;
}

// Deactivated (archived) and incomplete (draft) datasets stay listed so existing recipes keep resolving them,
// but neither may seed a new recipe.
export const isSelectableRheology = ({ isComplete, isDeactivated }: RheologyAvailability): boolean => (
  isDeactivated !== true && isComplete !== false
);

export const selectableRheology = <T extends RheologyAvailability>(datasets: T[] | undefined): T[] => (
  filter(isSelectableRheology, datasets ?? [])
);

export const firstSelectableRheology = <T extends RheologyAvailability>(datasets: T[] | undefined): T | undefined => (
  find(isSelectableRheology, datasets ?? [])
);
